import { Breakpoint, Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { ImageProps } from 'src/components/image';

import { StyledAlert, StyledIcon, StyledTitle, StyledWrapper } from './alert.styled';

interface Props {
  icon: ImageProps;
  title: string;
  text: React.ReactNode;
}

export const Alert: FunctionComponent<Props> = (props: Props) => {
  const { icon, title, text, ...rest } = props;

  return (
    <StyledAlert {...rest}>
      <StyledWrapper>
        <StyledIcon {...icon} />
        <StyledTitle variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
          {title}
        </StyledTitle>
      </StyledWrapper>
      <Typography variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
        {text}
      </Typography>
    </StyledAlert>
  );
};
